import React, { useEffect, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';
import withTheme from '../../../../hoc/withTheme';
import palette from '../../../../theme/Palette';
import withContent from '../../../../hoc/withContent';
import CtaButton from '../../../CtaButton';
import posed from 'react-pose';
import LaptopShape from './LaptopShape';
import TopLeftShape from './TopLeftShape';

const Container = posed.div({
  enter: { staggerChildren: 50 },
});

const Title = posed.h1({
  open: { y: 0, opacity: 1 },
  closed: { y: 20, opacity: 0 },
});

const PlanetRed = posed.path({
  open: { x: 0, opacity: 1, delay: 1000 },
  closed: { x: 20, opacity: 0, delay: 1000 },
});

const PlanetPink = posed.path({
  open: { x: 0, opacity: 1, delay: 800 },
  closed: { x: 20, opacity: 0, delay: 800 },
});

const PlanetPurple = posed.path({
  open: { x: 0, opacity: 1, delay: 600 },
  closed: { x: 20, opacity: 0, delay: 600 },
});

const PlanetRedPurple = posed.path({
  open: { x: 0, opacity: 1, delay: 400 },
  closed: { x: 20, opacity: 0, delay: 400 },
});

const PlanetBlue = posed.path({
  open: { x: 0, opacity: 1, delay: 200 },
  closed: { x: 20, opacity: 0, delay: 200 },
});

const PlanetGreen = posed.path({
  open: { x: 0, opacity: 1 },
  closed: { x: 20, opacity: 0 },
});

const AboutPageShape = ({ classes, bIsDark, objContent, intContentIndex }) => {
  const [bIsOpen, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
  }, []);

  const { title_aboutpage: arrAboutTitle = [], cta_text_about: strCta } = objContent[intContentIndex].data;
  const arrFormattedAboutTitle = arrAboutTitle.map((objContent) => objContent.text);
  return (
    <div className={classes.containerAbout}>
      <Container className={classes.shape__containerAbout}>
        <Title pose={bIsOpen ? 'open' : 'closed'} className={classes.header__titleAbout}>
          {arrFormattedAboutTitle[0]}
          <br />
          {arrFormattedAboutTitle[1]}
        </Title>
        <div className={classes.header__ctaAbout}>
          <CtaButton strButtonText={strCta[0].text} strLink={'/contact'} />
        </div>
        <LaptopShape />
        <TopLeftShape />
      </Container>
      <svg className={classes.about__mainSvg} viewBox="0 0 2577 1321" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
          <PlanetGreen
            pose={bIsOpen ? 'open' : 'closed'}
            d="M2466.36 1083.78C2467.9 1081.76 2470.52 1079.17 2474.8 1075.81C2482.44 1069.81 2493.37 1063 2505.55 1056.63C2521.66 1048.21 2553.38 1034.19 2558.14 1041.37L2555.78 1042.6C2555.77 1042.58 2553.74 1040.59 2540.61 1044.71C2531.12 1047.69 2519.25 1052.8 2507.19 1059.1C2495.13 1065.4 2484.34 1072.13 2476.8 1078.05C2466.37 1086.24 2467.34 1088.78 2467.36 1088.81L2465 1090.04C2464.24 1088.89 2463.83 1087.11 2466.36 1083.78Z"
            fill="#2D8C8D"
          />
        </g>
        <PlanetGreen
          pose={bIsOpen ? 'open' : 'closed'}
          d="M2485.79 1082.36C2493.09 1097.03 2510.92 1103.02 2525.61 1095.73C2540.3 1088.44 2546.3 1070.64 2539 1055.97C2531.7 1041.3 2513.87 1035.32 2499.17 1042.6C2484.48 1049.89 2478.49 1067.69 2485.79 1082.36Z"
          fill="url(#paint0_linear_greenPlanet)"
        />
        <PlanetGreen
          pose={bIsOpen ? 'open' : 'closed'}
          d="M2510.54 1082.94V1082.88H2512.5V1082.82H2514.4V1082.75H2515.69V1082.69H2516.55V1082.63H2517.35V1082.57H2518.2V1082.51H2519.06V1082.45H2519.92V1082.39H2520.78V1082.33H2521.64V1082.27H2522.43V1082.21H2522.93V1082.15H2523.48V1082.08H2523.97V1082.02H2524.46V1081.96H2525.01V1081.9H2525.5V1081.84H2525.99V1081.78H2526.54V1081.72H2527.03V1081.66H2527.52V1081.6H2528.01V1081.54H2528.57V1081.48H2529.06V1081.41H2529.55V1081.35H2529.98V1081.29H2530.34V1081.23H2530.71V1081.17H2531.08V1081.11H2531.45V1081.05H2531.88V1080.99H2532.24V1080.93H2532.61V1080.87H2532.98V1080.8H2533.35V1080.74H2533.78V1080.68H2534.15V1080.62H2534.51V1080.56H2534.88V1080.5H2535.19V1080.44H2535.56V1080.38H2535.86V1080.32H2536.17V1080.26H2536.48V1080.2H2536.78V1080.13H2537.09V1080.07H2537.4V1080.01H2537.7V1079.95H2538.01V1079.89H2538.32V1079.83H2538.5V1079.71H2538.56V1078.25H2538.62V1076.84H2538.56V1075.99H2538.5V1075.44H2538.32V1075.5H2538.01V1075.56H2537.7V1075.62H2537.4V1075.69H2537.03V1075.75H2536.66V1075.81H2536.35V1075.87H2535.99V1075.93H2535.62V1075.99H2535.19V1076.05H2534.76V1076.11H2534.33V1076.17H2533.9V1076.23H2533.53V1076.3H2532.98V1076.36H2532.49V1076.42H2531.94V1076.48H2531.39V1076.54H2530.83V1076.6H2530.1V1076.66H2529.42V1076.72H2528.69V1076.78H2527.83V1076.84H2526.79V1076.9H2525.75V1076.97H2524.15V1077.03H2522.13V1077.09H2512.38V1077.03H2508.52V1076.97H2505.39V1076.9H2502.87V1076.84H2500.79V1076.78H2499.2V1076.72H2497.6V1076.66H2496.19V1076.6H2495.09V1076.54H2493.98V1076.48H2492.88V1076.42H2492.08V1076.36H2491.72V1079.28H2491.78V1080.01H2491.84V1080.68H2491.9V1081.17H2491.96V1081.48H2492.02V1081.84H2492.08V1082.08H2492.14V1082.15H2492.7V1082.21H2493.37V1082.27H2493.98V1082.33H2494.6V1082.39H2495.33V1082.45H2496.19V1082.51H2497.17V1082.57H2498.15V1082.63H2499.13V1082.69H2500.12V1082.75H2501.1V1082.82H2503.18V1082.88H2505.2V1082.94H2510.54ZM2524.76 1075.2V1075.14H2526.6V1075.08H2527.71V1075.02H2528.63V1074.95H2529.42V1074.89H2530.1V1074.83H2530.83V1074.77H2531.39V1074.71H2532V1074.65H2532.55V1074.59H2533.1V1074.53H2533.59V1074.47H2534.08V1074.41H2534.57V1074.35H2535V1074.28H2535.49V1074.22H2535.92V1074.16H2536.35V1074.1H2536.78V1074.04H2537.21V1073.98H2537.64V1073.92H2538.01V1073.86H2538.25V1073.61H2538.19V1073.31H2538.13V1072.94H2538.07V1072.64H2538.01V1072.4H2537.95V1072.15H2537.89V1071.91H2537.82V1071.72H2537.76V1071.48H2537.7V1071.3H2537.64V1071.05H2537.58V1070.87H2537.52V1070.63H2537.46V1070.45H2537.4V1070.26H2537.33V1070.08H2537.27V1069.96H2537.21V1069.77H2537.15V1069.59H2537.09V1069.47H2537.03V1069.29H2536.97V1069.17H2536.6V1069.23H2535.86V1069.29H2535.19V1069.35H2534.51V1069.41H2533.84V1069.47H2533.23V1069.53H2532.61V1069.59H2532V1069.65H2531.45V1069.71H2530.9V1069.77H2530.41V1069.84H2529.85V1069.9H2529.42V1069.96H2528.93V1070.02H2528.44V1070.08H2528.01V1070.14H2527.59V1070.2H2527.16V1070.26H2526.79V1070.32H2526.42V1070.38H2526.05V1070.45H2525.62V1070.51H2525.32V1070.57H2524.95V1070.63H2524.64V1070.69H2524.34V1070.75H2523.97V1070.81H2523.72V1070.87H2523.42V1070.93H2523.17V1070.99H2522.86V1071.05H2522.62V1071.12H2522.37V1071.18H2522.13V1071.24H2521.88V1071.3H2521.64V1071.36H2521.39V1071.42H2521.21V1071.48H2521.02V1071.54H2520.78V1071.6H2520.6V1071.66H2520.41V1071.72H2520.23V1071.79H2520.04V1071.85H2519.92V1071.91H2519.74V1071.97H2519.61V1072.03H2519.43V1072.09H2519.31V1072.15H2519.18V1072.21H2519.06V1072.27H2518.94V1072.33H2518.82V1072.4H2518.69V1072.46H2518.57V1072.52H2518.45V1072.58H2518.39V1072.64H2518.27V1072.7H2518.2V1072.76H2518.08V1072.82H2518.02V1072.88H2517.9V1072.94H2517.84V1073.07H2517.77V1073.13H2517.71V1073.19H2517.65V1073.25H2517.59V1073.31H2517.53V1073.37H2517.47V1073.49H2517.41V1073.61H2517.35V1073.74H2517.28V1073.92H2517.35V1073.98H2517.41V1074.04H2517.47V1074.1H2517.59V1074.16H2517.65V1074.22H2517.77V1074.28H2517.9V1074.35H2518.02V1074.41H2518.14V1074.47H2518.27V1074.53H2518.45V1074.59H2518.63V1074.65H2518.82V1074.71H2519.06V1074.77H2519.31V1074.83H2519.61V1074.89H2519.98V1074.95H2520.41V1075.02H2520.96V1075.08H2521.64V1075.14H2523.17V1075.2"
          fill="url(#paint1_linear_greenPlanetStripes)"
        />
        <PlanetGreen
          pose={bIsOpen ? 'open' : 'closed'}
          d="M2514.04 1066.3V1066.24H2512.03V1066.17H2510.09V1066.11H2508.77V1066.05H2507.89V1065.99H2507.08V1065.92H2506.2V1065.86H2505.32V1065.8H2504.45V1065.74H2503.57V1065.68H2502.69V1065.61H2501.87V1065.55H2501.37V1065.49H2500.81V1065.43H2500.31V1065.36H2499.81V1065.3H2499.24V1065.24H2498.74V1065.18H2498.24V1065.11H2497.67V1065.05H2497.17V1064.99H2496.67V1064.93H2496.17V1064.87H2495.6V1064.8H2495.1V1064.74H2494.6V1064.68H2494.16V1064.62H2493.78V1064.55H2493.41V1064.49H2493.03V1064.43H2492.66V1064.37H2492.22V1064.3H2491.84V1064.24H2491.46V1064.18H2491.09V1064.12H2490.71V1064.05H2490.27V1063.99H2489.9V1063.93H2489.52V1063.87H2489.14V1063.81H2488.83V1063.74H2488.45V1063.68H2488.14V1063.62H2487.83V1063.56H2487.51V1063.49H2487.2V1063.43H2486.89V1063.37H2486.57V1063.31H2486.26V1063.24H2485.95V1063.18H2485.63V1063.12H2485.44V1063H2485.38V1061.5H2485.32V1060.07H2485.38V1059.19H2485.44V1058.63H2485.63V1058.69H2485.95V1058.76H2486.26V1058.82H2486.57V1058.88H2486.95V1058.94H2487.33V1059.01H2487.64V1059.07H2488.02V1059.13H2488.39V1059.19H2488.83V1059.26H2489.27V1059.32H2489.71V1059.38H2490.15V1059.44H2490.52V1059.51H2491.09V1059.57H2491.59V1059.63H2492.15V1059.69H2492.72V1059.75H2493.28V1059.82H2494.04V1059.88H2494.73V1059.94H2495.48V1060H2496.36V1060.07H2497.42V1060.13H2498.49V1060.19H2500.12V1060.25H2502.19V1060.32H2512.16V1060.25H2516.11V1060.19H2519.31V1060.13H2521.88V1060.07H2524.01V1060H2525.64V1059.94H2527.27V1059.88H2528.71V1059.82H2529.84V1059.75H2530.97V1059.69H2532.1V1059.63H2532.92V1059.57H2533.29V1062.56H2533.23V1063.31H2533.17V1063.99H2533.1V1064.49H2533.04V1064.8H2532.98V1065.18H2532.92V1065.43H2532.85V1065.49H2532.29V1065.55H2531.6V1065.61H2530.97V1065.68H2530.34V1065.74H2529.59V1065.8H2528.71V1065.86H2527.71V1065.92H2526.71V1065.99H2525.7V1066.05H2524.7V1066.11H2523.7V1066.17H2521.57V1066.24H2519.5V1066.3H2514.04ZM2499.49 1058.38V1058.32H2497.61V1058.26H2496.48V1058.2H2495.54V1058.13H2494.73V1058.07H2494.04V1058.01H2493.28V1057.95H2492.72V1057.88H2492.09V1057.82H2491.53V1057.76H2490.96V1057.7H2490.46V1057.64H2489.96V1057.57H2489.46V1057.51H2489.02V1057.45H2488.52V1057.39H2488.08V1057.32H2487.64V1057.26H2487.2V1057.2H2486.76V1057.14H2486.32V1057.07H2485.95V1057.01H2485.7V1056.76H2485.76V1056.45H2485.82V1056.08H2485.88V1055.77H2485.95V1055.52H2486.01V1055.27H2486.07V1055.02H2486.13V1054.83H2486.2V1054.58H2486.26V1054.39H2486.32V1054.15H2486.39V1053.96H2486.45V1053.71H2486.51V1053.52H2486.57V1053.34H2486.64V1053.15H2486.7V1053.02H2486.76V1052.84H2486.82V1052.65H2486.89V1052.52H2486.95V1052.34H2487.01V1052.21H2487.39V1052.28H2488.14V1052.34H2488.83V1052.4H2489.52V1052.46H2490.21V1052.52H2490.84V1052.59H2491.46V1052.65H2492.09V1052.71H2492.66V1052.77H2493.22V1052.84H2493.72V1052.9H2494.29V1052.96H2494.73V1053.02H2495.23V1053.09H2495.73V1053.15H2496.17V1053.21H2496.61V1053.27H2497.05V1053.34H2497.42V1053.4H2497.8V1053.46H2498.17V1053.52H2498.61V1053.58H2498.93V1053.65H2499.3V1053.71H2499.62V1053.77H2499.93V1053.83H2500.31V1053.9H2500.56V1053.96H2500.87V1054.02H2501.12V1054.08H2501.44V1054.15H2501.69V1054.21H2501.94V1054.27H2502.19V1054.33H2502.44V1054.39H2502.69V1054.46H2502.94V1054.52H2503.13V1054.58H2503.32V1054.64H2503.57V1054.71H2503.76V1054.77H2503.94V1054.83H2504.13V1054.89H2504.32V1054.96H2504.45V1055.02H2504.63V1055.08H2504.76V1055.14H2504.95V1055.2H2505.07V1055.27H2505.2V1055.33H2505.32V1055.39H2505.45V1055.45H2505.57V1055.52H2505.7V1055.58H2505.83V1055.64H2505.95V1055.7H2506.01V1055.77H2506.14V1055.83H2506.2V1055.89H2506.33V1055.95H2506.39V1056.02H2506.51V1056.08H2506.58V1056.2H2506.64V1056.26H2506.7V1056.33H2506.77V1056.39H2506.83V1056.45H2506.89V1056.51H2506.95V1056.64H2507.02V1056.76H2507.08V1056.89H2507.14V1057.07H2507.08V1057.14H2507.02V1057.2H2506.95V1057.26H2506.83V1057.32H2506.77V1057.39H2506.64V1057.45H2506.51V1057.51H2506.39V1057.57H2506.26V1057.64H2506.14V1057.7H2505.95V1057.76H2505.76V1057.82H2505.57V1057.88H2505.32V1057.95H2505.07V1058.01H2504.76V1058.07H2504.38V1058.13H2503.94V1058.2H2503.38V1058.26H2502.69V1058.32H2501.12V1058.38"
          fill="url(#paint2_linear)"
        />
        <PlanetGreen
          pose={bIsOpen ? 'open' : 'closed'}
          d="M2471.37 1091.07C2473.83 1091.07 2477.37 1090.53 2482.48 1089.08C2491.61 1086.5 2503.29 1081.69 2515.37 1075.53C2531.33 1067.39 2560.8 1049.73 2558.07 1041.17L2555.74 1042.35C2555.75 1042.38 2556.09 1045.35 2545.18 1053.73C2537.3 1059.79 2526.38 1066.48 2514.42 1072.58C2502.47 1078.67 2490.93 1083.43 2481.93 1085.98C2469.48 1089.5 2468.09 1087.06 2468.08 1087.03L2465.75 1088.22C2466.19 1089.59 2467.32 1091.07 2471.37 1091.07Z"
          fill="#349FA0"
        />
        <path
          d="M2033.18 440.554C2033.18 662.777 1372.73 936.786 1008.07 1062.53C469.921 1236.28 1086.46 511.133 735.958 485.985C293.404 389.965 1332.89 -210.354 1284.18 77.3852C1247.57 293.646 2033.18 218.331 2033.18 440.554Z"
          fill="url(#paint3_linear)"
        />

        <path
          d="M1071 162.5C1071 163.881 1069.88 165 1068.5 165C1067.12 165 1066 163.881 1066 162.5C1066 161.119 1067.12 160 1068.5 160C1069.88 160 1071 161.119 1071 162.5Z"
          fill="white"
        />
        <path
          d="M812 461.5C812 459.567 810.433 458 808.5 458C806.567 458 805 459.567 805 461.5C805 463.433 806.567 465 808.5 465C810.433 465 812 463.433 812 461.5Z"
          fill="white"
        />
        <path
          d="M842 452C842 450.895 841.105 450 840 450C838.895 450 838 450.895 838 452C838 453.105 838.895 454 840 454C841.105 454 842 453.105 842 452Z"
          fill="white"
        />
        <path
          d="M922 171.5C922 169.567 920.433 168 918.5 168C916.567 168 915 169.567 915 171.5C915 173.433 916.567 175 918.5 175C920.433 175 922 173.433 922 171.5Z"
          fill="white"
        />
        <path
          d="M1187 153.5C1187 151.567 1185.43 150 1183.5 150C1181.57 150 1180 151.567 1180 153.5C1180 155.433 1181.57 157 1183.5 157C1185.43 157 1187 155.433 1187 153.5Z"
          fill="white"
        />
        <path
          d="M1084.81 175C1084.81 177.209 1083.02 179 1080.81 179C1078.6 179 1076.81 177.209 1076.81 175C1076.81 172.791 1078.6 171 1080.81 171C1083.02 171 1084.81 172.791 1084.81 175Z"
          fill="white"
        />
        <path
          d="M775.499 363C775.499 359.687 772.59 357 769 357C772.59 357 775.499 354.315 775.499 351C775.499 354.315 778.41 357 782 357C778.41 357 775.499 359.687 775.499 363Z"
          fill="white"
        />
        <path
          d="M872.499 226C872.499 221.858 869.142 218.5 865 218.5C869.142 218.5 872.499 215.143 872.499 211C872.499 215.143 875.858 218.5 880 218.5C875.858 218.5 872.499 221.858 872.499 226Z"
          fill="white"
        />
        <PlanetRed
          pose={bIsOpen ? 'open' : 'closed'}
          d="M1814.32 286.173C1814.32 302.838 1800.81 316.347 1784.16 316.347C1767.5 316.347 1754 302.838 1754 286.173C1754 269.509 1767.5 256 1784.16 256C1800.81 256 1814.32 269.509 1814.32 286.173Z"
          fill="url(#paint4_linear)"
        />
        <ellipse cx="1256" cy="247" rx="96" ry="97" fill="url(#paint5_linear)" />
        <g clipPath="url(#clip1)">
          <PlanetPink
            pose={bIsOpen ? 'open' : 'closed'}
            d="M711.132 586.823C710.117 585.485 708.386 583.77 705.555 581.542C700.501 577.564 693.282 573.05 685.227 568.832C674.581 563.255 653.615 553.967 650.468 558.723L652.025 559.538C652.034 559.524 653.378 558.205 662.055 560.935C668.326 562.908 676.171 566.294 684.143 570.47C692.116 574.646 699.251 579.105 704.233 583.026C711.127 588.453 710.482 590.137 710.473 590.152L712.03 590.967C712.532 590.207 712.803 589.026 711.132 586.823Z"
            fill="#8F3391"
          />
        </g>
        <PlanetPink
          pose={bIsOpen ? 'open' : 'closed'}
          d="M698.29 585.883C693.465 595.602 681.679 599.566 671.968 594.737C662.256 589.908 658.295 578.113 663.12 568.394C667.946 558.675 679.731 554.711 689.443 559.54C699.155 564.369 703.116 576.164 698.29 585.883Z"
          fill="url(#paint6_linear)"
        />
        <PlanetPink
          pose={bIsOpen ? 'open' : 'closed'}
          d="M681.931 586.263V586.223H680.634V586.182H679.377V586.142H678.526V586.102H677.959V586.061H677.432V586.021H676.864V585.98H676.297V585.94H675.729V585.9H675.162V585.859H674.595V585.819H674.068V585.779H673.744V585.738H673.379V585.698H673.055V585.657H672.73V585.617H672.366V585.577H672.041V585.536H671.717V585.496H671.352V585.456H671.028V585.415H670.704V585.375H670.38V585.334H670.015V585.294H669.691V585.254H669.366V585.213H669.083V585.173H668.839V585.133H668.596V585.092H668.353V585.052H668.11V585.011H667.826V584.971H667.583V584.931H667.34V584.89H667.097V584.85H666.854V584.81H666.57V584.769H666.327V584.729H666.083V584.688H665.84V584.648H665.638V584.608H665.394V584.567H665.192V584.527H664.989V584.487H664.786V584.446H664.584V584.406H664.381V584.365H664.179V584.325H663.976V584.285H663.773V584.244H663.571V584.204H663.449V584.123H663.408V583.154H663.368V582.226H663.408V581.66H663.449V581.297H663.571V581.337H663.773V581.378H663.976V581.418H664.179V581.458H664.422V581.499H664.665V581.539H664.868V581.58H665.111V581.62H665.354V581.66H665.638V581.701H665.921V581.741H666.205V581.781H666.489V581.822H666.732V581.862H667.097V581.903H667.421V581.943H667.786V581.983H668.15V582.024H668.515V582.064H669.002V582.104H669.447V582.145H669.934V582.185H670.501V582.226H671.19V582.266H671.879V582.306H672.933V582.347H674.27V582.387H680.715V582.347H683.268V582.306H685.335V582.266H686.997V582.226H688.375V582.185H689.429V582.145H690.482V582.104H691.414V582.064H692.144V582.024H692.874V581.983H693.603V581.943H694.13V581.903H694.373V583.841H694.333V584.325H694.292V584.769H694.252V585.092H694.211V585.294H694.17V585.536H694.13V585.698H694.089V585.738H693.725V585.779H693.279V585.819H692.874V585.859H692.468V585.9H691.982V585.94H691.414V585.98H690.766V586.021H690.118V586.061H689.469V586.102H688.821V586.142H688.172V586.182H686.794V586.223H685.457V586.263H681.931ZM672.528 581.135V581.095H671.312V581.055H670.582V581.014H669.974V580.974H669.447V580.934H669.002V580.893H668.515V580.853H668.15V580.812H667.745V580.772H667.38V580.732H667.016V580.691H666.691V580.651H666.367V580.611H666.043V580.57H665.759V580.53H665.435V580.489H665.151V580.449H664.868V580.409H664.584V580.368H664.3V580.328H664.016V580.288H663.773V580.247H663.611V580.086H663.652V579.884H663.692V579.642H663.733V579.44H663.773V579.278H663.814V579.117H663.854V578.955H663.895V578.834H663.935V578.673H663.976V578.551H664.016V578.39H664.057V578.269H664.097V578.107H664.138V577.986H664.179V577.865H664.219V577.744H664.26V577.663H664.3V577.542H664.341V577.421H664.381V577.34H664.422V577.219H664.462V577.138H664.705V577.179H665.192V577.219H665.638V577.259H666.083V577.3H666.529V577.34H666.935V577.381H667.34V577.421H667.745V577.461H668.11V577.502H668.475V577.542H668.799V577.582H669.164V577.623H669.447V577.663H669.772V577.704H670.096V577.744H670.38V577.784H670.663V577.825H670.947V577.865H671.19V577.905H671.433V577.946H671.677V577.986H671.96V578.027H672.163V578.067H672.406V578.107H672.609V578.148H672.811V578.188H673.055V578.228H673.217V578.269H673.419V578.309H673.581V578.35H673.784V578.39H673.946V578.43H674.108V578.471H674.27V578.511H674.433V578.551H674.595V578.592H674.757V578.632H674.878V578.673H675V578.713H675.162V578.753H675.284V578.794H675.405V578.834H675.527V578.874H675.648V578.915H675.729V578.955H675.851V578.996H675.932V579.036H676.054V579.076H676.135V579.117H676.216V579.157H676.297V579.197H676.378V579.238H676.459V579.278H676.54V579.319H676.621V579.359H676.702V579.399H676.743V579.44H676.824V579.48H676.864V579.52H676.945V579.561H676.986V579.601H677.067V579.642H677.108V579.722H677.148V579.763H677.189V579.803H677.229V579.843H677.27V579.884H677.31V579.924H677.351V580.005H677.391V580.086H677.432V580.166H677.472V580.288H677.432V580.328H677.391V580.368H677.351V580.409H677.27V580.449H677.229V580.489H677.148V580.53H677.067V580.57H676.986V580.611H676.905V580.651H676.824V580.691H676.702V580.732H676.581V580.772H676.459V580.812H676.297V580.853H676.135V580.893H675.932V580.934H675.689V580.974H675.405V581.014H675.04V581.055H674.595V581.095H673.581V581.135"
          fill="url(#paint7_linear)"
        />
        <PlanetPink
          pose={bIsOpen ? 'open' : 'closed'}
          d="M679.617 575.239V575.198H680.943V575.156H682.228V575.115H683.098V575.074H683.679V575.032H684.218V574.991H684.798V574.95H685.378V574.908H685.958V574.867H686.539V574.826H687.119V574.785H687.658V574.743H687.99V574.702H688.363V574.661H688.694V574.619H689.026V574.578H689.399V574.537H689.731V574.496H690.062V574.454H690.435V574.413H690.767V574.372H691.098V574.33H691.43V574.289H691.803V574.248H692.135V574.206H692.466V574.165H692.756V574.124H693.005V574.083H693.254V574.041H693.503V574H693.751V573.959H694.041V573.917H694.29V573.876H694.539V573.835H694.788V573.794H695.036V573.752H695.326V573.711H695.575V573.67H695.824V573.628H696.072V573.587H696.28V573.546H696.528V573.505H696.736V573.463H696.943V573.422H697.15V573.381H697.357V573.339H697.565V573.298H697.772V573.257H697.979V573.215H698.186V573.174H698.394V573.133H698.518V573.05H698.56V572.059H698.601V571.11H698.56V570.531H698.518V570.16H698.394V570.201H698.186V570.242H697.979V570.284H697.772V570.325H697.523V570.366H697.275V570.408H697.067V570.449H696.819V570.49H696.57V570.531H696.28V570.573H695.99V570.614H695.699V570.655H695.409V570.697H695.161V570.738H694.788V570.779H694.456V570.82H694.083V570.862H693.71V570.903H693.337V570.944H692.839V570.986H692.383V571.027H691.886V571.068H691.306V571.11H690.601V571.151H689.896V571.192H688.819V571.233H687.451V571.275H680.86V571.233H678.249V571.192H676.135V571.151H674.435V571.11H673.026V571.068H671.948V571.027H670.87V570.986H669.917V570.944H669.171V570.903H668.425V570.862H667.679V570.82H667.14V570.779H666.891V572.761H666.933V573.257H666.974V573.711H667.015V574.041H667.057V574.248H667.098V574.496H667.14V574.661H667.181V574.702H667.554V574.743H668.01V574.785H668.425V574.826H668.839V574.867H669.337V574.908H669.917V574.95H670.58V574.991H671.243V575.032H671.907V575.074H672.57V575.115H673.233V575.156H674.642V575.198H676.01V575.239H679.617ZM689.233 569.995V569.953H690.477V569.912H691.223V569.871H691.845V569.829H692.383V569.788H692.839V569.747H693.337V569.706H693.71V569.664H694.124V569.623H694.497V569.582H694.87V569.54H695.202V569.499H695.534V569.458H695.865V569.417H696.155V569.375H696.487V569.334H696.777V569.293H697.067V569.251H697.357V569.21H697.648V569.169H697.938V569.127H698.186V569.086H698.352V568.921H698.311V568.715H698.269V568.467H698.228V568.26H698.186V568.095H698.145V567.93H698.104V567.765H698.062V567.641H698.021V567.476H697.979V567.352H697.938V567.187H697.896V567.063H697.855V566.898H697.813V566.774H697.772V566.65H697.731V566.526H697.689V566.443H697.648V566.32H697.606V566.196H697.565V566.113H697.523V565.989H697.482V565.907H697.233V565.948H696.736V565.989H696.28V566.031H695.824V566.072H695.368V566.113H694.953V566.154H694.539V566.196H694.124V566.237H693.751V566.278H693.378V566.32H693.047V566.361H692.674V566.402H692.383V566.443H692.052V566.485H691.72V566.526H691.43V566.567H691.14V566.609H690.85V566.65H690.601V566.691H690.352V566.733H690.104V566.774H689.813V566.815H689.606V566.856H689.357V566.898H689.15V566.939H688.943V566.98H688.694V567.022H688.528V567.063H688.321V567.104H688.155V567.145H687.948V567.187H687.782V567.228H687.617V567.269H687.451V567.311H687.285V567.352H687.119V567.393H686.953V567.434H686.829V567.476H686.705V567.517H686.539V567.558H686.414V567.6H686.29V567.641H686.166V567.682H686.041V567.724H685.958V567.765H685.834V567.806H685.751V567.847H685.627V567.889H685.544V567.93H685.461V567.971H685.378V568.013H685.295V568.054H685.212V568.095H685.129V568.136H685.047V568.178H684.964V568.219H684.922V568.26H684.839V568.302H684.798V568.343H684.715V568.384H684.674V568.426H684.591V568.467H684.549V568.549H684.508V568.591H684.466V568.632H684.425V568.673H684.383V568.715H684.342V568.756H684.3V568.838H684.259V568.921H684.218V569.004H684.176V569.127H684.218V569.169H684.259V569.21H684.3V569.251H684.383V569.293H684.425V569.334H684.508V569.375H684.591V569.417H684.674V569.458H684.756V569.499H684.839V569.54H684.964V569.582H685.088V569.623H685.212V569.664H685.378V569.706H685.544V569.747H685.751V569.788H686V569.829H686.29V569.871H686.663V569.912H687.119V569.953H688.155V569.995"
          fill="url(#paint8_linear)"
        />
        <PlanetPink
          pose={bIsOpen ? 'open' : 'closed'}
          d="M707.821 591.653C706.195 591.653 703.857 591.292 700.478 590.333C694.445 588.622 686.726 585.433 678.741 581.353C668.188 575.961 648.706 564.263 650.511 558.587L652.054 559.375C652.048 559.392 651.825 561.362 659.032 566.913C664.239 570.926 671.46 575.36 679.363 579.397C687.266 583.436 694.894 586.589 700.841 588.276C709.072 590.61 709.987 588.995 709.993 588.977L711.536 589.766C711.247 590.674 710.499 591.653 707.821 591.653Z"
          fill="#8F3391"
        />
        <path
          d="M983 347C983 345.895 982.105 345 981 345C979.895 345 979 345.895 979 347C979 348.105 979.895 349 981 349C982.105 349 983 348.105 983 347Z"
          fill="white"
        />
        <path
          d="M719 393C719 395.209 717.209 397 715 397C712.791 397 711 395.209 711 393C711 390.791 712.791 389 715 389C717.209 389 719 390.791 719 393Z"
          fill="white"
        />
        <path
          d="M1142.5 77C1142.5 71.7539 1138.25 67.5 1133 67.5C1138.25 67.5 1142.5 63.2483 1142.5 58C1142.5 63.2483 1146.75 67.5 1152 67.5C1146.75 67.5 1142.5 71.7539 1142.5 77Z"
          fill="white"
        />
        <path
          d="M1463 101.5C1463 102.881 1461.88 104 1460.5 104C1459.12 104 1458 102.881 1458 101.5C1458 100.119 1459.12 99 1460.5 99C1461.88 99 1463 100.119 1463 101.5Z"
          fill="white"
        />
        <path
          d="M1579 92.5C1579 90.567 1577.43 89 1575.5 89C1573.57 89 1572 90.567 1572 92.5C1572 94.433 1573.57 96 1575.5 96C1577.43 96 1579 94.433 1579 92.5Z"
          fill="white"
        />
        <path
          d="M1476.81 114C1476.81 116.209 1475.02 118 1472.81 118C1470.6 118 1468.81 116.209 1468.81 114C1468.81 111.791 1470.6 110 1472.81 110C1475.02 110 1476.81 111.791 1476.81 114Z"
          fill="white"
        />
        <PlanetRedPurple
          className={classes.planet__redPurple}
          pose={bIsOpen ? 'open' : 'closed'}
          d="M972.913 1170.94C954.362 1152.2 954.362 1121.8 972.913 1103.06C991.462 1084.31 1021.54 1084.31 1040.09 1103.06C1058.64 1121.8 1058.64 1152.2 1040.09 1170.94C1021.54 1189.69 991.462 1189.69 972.913 1170.94Z"
          fill="url(#paint9_linear)"
        />
        <path
          d="M1724.78 822.046C1635.74 731.45 1635.74 584.55 1724.78 493.954C1813.82 403.349 1958.18 403.349 2047.22 493.954C2136.26 584.55 2136.26 731.45 2047.22 822.046C1958.18 912.651 1813.82 912.651 1724.78 822.046Z"
          fill="url(#paint10_radial)"
        />
        <path
          d="M1762.11 787.008C1693.96 717.695 1693.96 605.303 1762.11 535.99C1830.26 466.669 1940.74 466.669 2008.89 535.99C2077.04 605.303 2077.04 717.695 2008.89 787.008C1940.74 856.329 1830.26 856.329 1762.11 787.008Z"
          fill="url(#paint11_linear)"
        />
        <PlanetPurple
          pose={bIsOpen ? 'open' : 'closed'}
          d="M667.316 945.173C667.316 961.838 653.814 975.347 637.158 975.347C620.502 975.347 607 961.838 607 945.173C607 928.509 620.502 915 637.158 915C653.814 915 667.316 928.509 667.316 945.173Z"
          fill="url(#paint70_linear)"
        />
        <path
          d="M724 353C724 356.314 721.314 359 718 359C714.686 359 712 356.314 712 353C712 349.686 714.686 347 718 347C721.314 347 724 349.686 724 353Z"
          fill="white"
        />
        <path
          d="M1416 41.5C1416 42.8807 1414.88 44 1413.5 44C1412.12 44 1411 42.8807 1411 41.5C1411 40.1193 1412.12 39 1413.5 39C1414.88 39 1416 40.1193 1416 41.5Z"
          fill="white"
        />
        <g clipPath="url(#clip2)">
          <PlanetBlue
            pose={bIsOpen ? 'open' : 'closed'}
            d="M1734.26 1227.43C1729.55 1222.14 1721.8 1215.43 1709.38 1206.8C1687.22 1191.39 1656.1 1174.12 1621.75 1158.18C1576.37 1137.12 1487.77 1102.51 1477.34 1122.32L1483.97 1125.41C1484.01 1125.34 1488.79 1119.78 1524.94 1129.57C1551.06 1136.65 1584.17 1149.23 1618.16 1165.01C1652.15 1180.79 1682.91 1197.84 1704.76 1213.03C1735 1234.06 1733.19 1241 1733.16 1241.06L1739.8 1244.14C1741.46 1240.97 1742 1236.13 1734.26 1227.43Z"
            fill="#98B8DC"
          />
        </g>
        <PlanetBlue
          pose={bIsOpen ? 'open' : 'closed'}
          d="M1665.03 1211.87C1649.98 1242.07 1613.23 1254.39 1582.94 1239.38C1552.65 1224.37 1540.3 1187.72 1555.35 1157.52C1570.4 1127.32 1607.15 1115 1637.44 1130.01C1667.73 1145.01 1680.08 1181.66 1665.03 1211.87Z"
          fill="url(#paint71_linear)"
        />
        <PlanetBlue
          pose={bIsOpen ? 'open' : 'closed'}
          d="M1614.01 1213.05V1212.92H1609.97V1212.8H1606.05V1212.67H1603.39V1212.55H1601.62V1212.42H1599.98V1212.3H1598.21V1212.17H1596.44V1212.04H1594.67V1211.92H1592.9V1211.79H1591.13V1211.67H1589.49V1211.54H1588.48V1211.42H1587.34V1211.29H1586.33V1211.17H1585.32V1211.04H1584.18V1210.92H1583.17V1210.79H1582.16V1210.66H1581.02V1210.54H1580.01V1210.41H1579V1210.29H1577.99V1210.16H1576.85V1210.04H1575.84V1209.91H1574.83V1209.79H1573.94V1209.66H1573.18V1209.54H1572.42V1209.41H1571.67V1209.28H1570.91V1209.16H1570.02V1209.03H1569.26V1208.91H1568.51V1208.78H1567.75V1208.66H1566.99V1208.53H1566.1V1208.41H1565.35V1208.28H1564.59V1208.16H1563.83V1208.03H1563.2V1207.9H1562.44V1207.78H1561.81V1207.65H1561.17V1207.53H1560.54V1207.4H1559.91V1207.28H1559.28V1207.15H1558.65V1207.03H1558.01V1206.9H1557.38V1206.78H1556.75V1206.65H1556.37V1206.4H1556.24V1203.39H1556.12V1200.5H1556.24V1198.75H1556.37V1197.62H1556.75V1197.74H1557.38V1197.87H1558.01V1197.99H1558.65V1198.12H1559.4V1198.24H1560.16V1198.37H1560.79V1198.49H1561.55V1198.62H1562.31V1198.75H1563.2V1198.87H1564.08V1199H1564.97V1199.12H1565.85V1199.25H1566.61V1199.37H1567.75V1199.5H1568.76V1199.62H1569.9V1199.75H1571.03V1199.87H1572.17V1200H1573.69V1200.13H1575.08V1200.25H1576.6V1200.38H1578.36V1200.5H1580.51V1200.63H1582.66V1200.75H1585.95V1200.88H1590.12V1201H1610.22V1200.88H1618.18V1200.75H1624.63V1200.63H1629.81V1200.5H1634.11V1200.38H1637.4V1200.25H1640.68V1200.13H1643.59V1200H1645.86V1199.87H1648.14V1199.75H1650.42V1199.62H1652.06V1199.5H1652.82V1205.52H1652.69V1207.03H1652.56V1208.41H1652.44V1209.41H1652.31V1210.04H1652.19V1210.79H1652.06V1211.29H1651.93V1211.42H1650.79V1211.54H1649.4V1211.67H1648.14V1211.79H1646.88V1211.92H1645.36V1212.04H1643.59V1212.17H1641.57V1212.3H1639.54V1212.42H1637.52V1212.55H1635.5V1212.67H1633.48V1212.8H1629.18V1212.92H1625.01V1213.05H1614.01ZM1584.69 1197.11V1196.99H1580.89V1196.86H1578.62V1196.74H1576.72V1196.61H1575.08V1196.49H1573.69V1196.36H1572.17V1196.24H1571.03V1196.11H1569.77V1195.99H1568.63V1195.86H1567.49V1195.73H1566.48V1195.61H1565.47V1195.48H1564.46V1195.36H1563.58V1195.23H1562.56V1195.11H1561.68V1194.98H1560.79V1194.86H1559.91V1194.73H1559.02V1194.61H1558.14V1194.48H1557.38V1194.35H1556.88V1193.85H1557V1193.23H1557.13V1192.47H1557.26V1191.85H1557.38V1191.34H1557.51V1190.84H1557.63V1190.34H1557.76V1189.96H1557.89V1189.46H1558.01V1189.09H1558.14V1188.58H1558.27V1188.21H1558.39V1187.7H1558.52V1187.33H1558.65V1186.95H1558.77V1186.58H1558.9V1186.32H1559.02V1185.95H1559.15V1185.57H1559.28V1185.32H1559.4V1184.94H1559.53V1184.69H1560.29V1184.82H1561.81V1184.94H1563.2V1185.07H1564.59V1185.2H1565.98V1185.32H1567.24V1185.45H1568.51V1185.57H1569.77V1185.7H1570.91V1185.82H1572.04V1185.95H1573.06V1186.07H1574.19V1186.2H1575.08V1186.32H1576.09V1186.45H1577.1V1186.58H1577.99V1186.7H1578.87V1186.83H1579.76V1186.95H1580.51V1187.08H1581.27V1187.2H1582.03V1187.33H1582.92V1187.45H1583.55V1187.58H1584.31V1187.7H1584.94V1187.83H1585.57V1187.96H1586.33V1188.08H1586.83V1188.21H1587.47V1188.33H1587.97V1188.46H1588.6V1188.58H1589.11V1188.71H1589.61V1188.83H1590.12V1188.96H1590.63V1189.09H1591.13V1189.21H1591.64V1189.34H1592.02V1189.46H1592.4V1189.59H1592.9V1189.71H1593.28V1189.84H1593.66V1189.96H1594.04V1190.09H1594.42V1190.21H1594.67V1190.34H1595.05V1190.47H1595.3V1190.59H1595.68V1190.72H1595.94V1190.84H1596.19V1190.97H1596.44V1191.09H1596.69V1191.22H1596.95V1191.34H1597.2V1191.47H1597.45V1191.59H1597.7V1191.72H1597.83V1191.85H1598.08V1191.97H1598.21V1192.1H1598.46V1192.22H1598.59V1192.35H1598.84V1192.47H1598.97V1192.72H1599.1V1192.85H1599.22V1192.97H1599.35V1193.1H1599.47V1193.23H1599.6V1193.35H1599.73V1193.6H1599.85V1193.85H1599.98V1194.1H1600.11V1194.48H1599.98V1194.61H1599.85V1194.73H1599.73V1194.86H1599.47V1194.98H1599.35V1195.11H1599.1V1195.23H1598.84V1195.36H1598.59V1195.48H1598.34V1195.61H1598.08V1195.73H1597.7V1195.86H1597.33V1195.99H1596.95V1196.11H1596.44V1196.24H1595.94V1196.36H1595.3V1196.49H1594.54V1196.61H1593.66V1196.74H1592.52V1196.86H1591.13V1196.99H1587.97V1197.11"
          fill="url(#paint72_linear)"
        />
        <PlanetBlue
          pose={bIsOpen ? 'open' : 'closed'}
          d="M1606.79 1178.79V1178.66H1610.93V1178.53H1614.94V1178.41H1617.65V1178.28H1619.46V1178.15H1621.14V1178.02H1622.95V1177.89H1624.76V1177.76H1626.57V1177.64H1628.38V1177.51H1630.19V1177.38H1631.87V1177.25H1632.91V1177.12H1634.07V1176.99H1635.11V1176.87H1636.14V1176.74H1637.3V1176.61H1638.34V1176.48H1639.37V1176.35H1640.54V1176.23H1641.57V1176.1H1642.6V1175.97H1643.64V1175.84H1644.8V1175.71H1645.84V1175.58H1646.87V1175.46H1647.78V1175.33H1648.55V1175.2H1649.33V1175.07H1650.1V1174.94H1650.88V1174.81H1651.78V1174.69H1652.56V1174.56H1653.33V1174.43H1654.11V1174.3H1654.89V1174.17H1655.79V1174.04H1656.57V1173.92H1657.34V1173.79H1658.12V1173.66H1658.76V1173.53H1659.54V1173.4H1660.19V1173.27H1660.83V1173.15H1661.48V1173.02H1662.13V1172.89H1662.77V1172.76H1663.42V1172.63H1664.06V1172.5H1664.71V1172.38H1665.36V1172.25H1665.75V1171.99H1665.87V1168.91H1666V1165.96H1665.87V1164.16H1665.75V1163.01H1665.36V1163.14H1664.71V1163.27H1664.06V1163.39H1663.42V1163.52H1662.64V1163.65H1661.87V1163.78H1661.22V1163.91H1660.44V1164.04H1659.67V1164.16H1658.76V1164.29H1657.86V1164.42H1656.95V1164.55H1656.05V1164.68H1655.27V1164.81H1654.11V1164.93H1653.08V1165.06H1651.91V1165.19H1650.75V1165.32H1649.59V1165.45H1648.03V1165.58H1646.61V1165.7H1645.06V1165.83H1643.25V1165.96H1641.05V1166.09H1638.86V1166.22H1635.49V1166.34H1631.23V1166.47H1610.67V1166.34H1602.53V1166.22H1595.94V1166.09H1590.64V1165.96H1586.24V1165.83H1582.88V1165.7H1579.52V1165.58H1576.54V1165.45H1574.22V1165.32H1571.89V1165.19H1569.56V1165.06H1567.88V1164.93H1567.11V1171.09H1567.24V1172.63H1567.37V1174.04H1567.49V1175.07H1567.62V1175.71H1567.75V1176.48H1567.88V1176.99H1568.01V1177.12H1569.18V1177.25H1570.6V1177.38H1571.89V1177.51H1573.18V1177.64H1574.73V1177.76H1576.54V1177.89H1578.61V1178.02H1580.68V1178.15H1582.75V1178.28H1584.82V1178.41H1586.89V1178.53H1591.28V1178.66H1595.55V1178.79H1606.79ZM1636.79 1162.5V1162.37H1640.67V1162.24H1642.99V1162.11H1644.93V1161.98H1646.61V1161.85H1648.03V1161.73H1649.59V1161.6H1650.75V1161.47H1652.04V1161.34H1653.21V1161.21H1654.37V1161.08H1655.4V1160.96H1656.44V1160.83H1657.47V1160.7H1658.38V1160.57H1659.41V1160.44H1660.32V1160.31H1661.22V1160.19H1662.13V1160.06H1663.03V1159.93H1663.94V1159.8H1664.71V1159.67H1665.23V1159.16H1665.1V1158.52H1664.97V1157.75H1664.84V1157.11H1664.71V1156.59H1664.58V1156.08H1664.45V1155.57H1664.32V1155.18H1664.19V1154.67H1664.06V1154.28H1663.94V1153.77H1663.81V1153.39H1663.68V1152.87H1663.55V1152.49H1663.42V1152.1H1663.29V1151.72H1663.16V1151.46H1663.03V1151.08H1662.9V1150.69H1662.77V1150.43H1662.64V1150.05H1662.51V1149.79H1661.74V1149.92H1660.19V1150.05H1658.76V1150.18H1657.34V1150.31H1655.92V1150.43H1654.63V1150.56H1653.33V1150.69H1652.04V1150.82H1650.88V1150.95H1649.71V1151.08H1648.68V1151.2H1647.52V1151.33H1646.61V1151.46H1645.58V1151.59H1644.54V1151.72H1643.64V1151.85H1642.73V1151.97H1641.83V1152.1H1641.05V1152.23H1640.28V1152.36H1639.5V1152.49H1638.6V1152.62H1637.95V1152.74H1637.17V1152.87H1636.53V1153H1635.88V1153.13H1635.11V1153.26H1634.59V1153.39H1633.94V1153.51H1633.43V1153.64H1632.78V1153.77H1632.26V1153.9H1631.75V1154.03H1631.23V1154.16H1630.71V1154.28H1630.19V1154.41H1629.68V1154.54H1629.29V1154.67H1628.9V1154.8H1628.38V1154.92H1628V1155.05H1627.61V1155.18H1627.22V1155.31H1626.83V1155.44H1626.57V1155.57H1626.19V1155.69H1625.93V1155.82H1625.54V1155.95H1625.28V1156.08H1625.02V1156.21H1624.76V1156.34H1624.51V1156.46H1624.25V1156.59H1623.99V1156.72H1623.73V1156.85H1623.47V1156.98H1623.34V1157.11H1623.08V1157.23H1622.95V1157.36H1622.7V1157.49H1622.57V1157.62H1622.31V1157.75H1622.18V1158H1622.05V1158.13H1621.92V1158.26H1621.79V1158.39H1621.66V1158.52H1621.53V1158.65H1621.4V1158.9H1621.27V1159.16H1621.14V1159.42H1621.02V1159.8H1621.14V1159.93H1621.27V1160.06H1621.4V1160.19H1621.66V1160.31H1621.79V1160.44H1622.05V1160.57H1622.31V1160.7H1622.57V1160.83H1622.83V1160.96H1623.08V1161.08H1623.47V1161.21H1623.86V1161.34H1624.25V1161.47H1624.76V1161.6H1625.28V1161.73H1625.93V1161.85H1626.7V1161.98H1627.61V1162.11H1628.77V1162.24H1630.19V1162.37H1633.43V1162.5"
          fill="url(#paint73_linear)"
        />
        <PlanetBlue
          pose={bIsOpen ? 'open' : 'closed'}
          d="M1724.7 1247.95C1717.69 1247.95 1707.6 1246.57 1693.03 1242.9C1667.01 1236.36 1633.71 1224.15 1599.27 1208.54C1553.75 1187.91 1469.72 1143.16 1477.51 1121.44L1484.16 1124.45C1484.14 1124.52 1483.17 1132.05 1514.26 1153.29C1536.72 1168.65 1567.86 1185.61 1601.95 1201.06C1636.04 1216.51 1668.94 1228.58 1694.59 1235.03C1730.1 1243.96 1734.04 1237.78 1734.07 1237.71L1740.73 1240.73C1739.48 1244.2 1736.25 1247.95 1724.7 1247.95Z"
          fill="#98B8DC"
        />

        <path
          d="M180 784.5C180 782.567 178.433 781 176.5 781C174.567 781 173 782.567 173 784.5C173 786.433 174.567 788 176.5 788C178.433 788 180 786.433 180 784.5Z"
          fill="white"
        />
        <path
          d="M402 742.5C402 740.567 400.433 739 398.5 739C396.567 739 395 740.567 395 742.5C395 744.433 396.567 746 398.5 746C400.433 746 402 744.433 402 742.5Z"
          fill="white"
        />
        <path
          d="M403 670C403 668.895 402.105 668 401 668C399.895 668 399 668.895 399 670C399 671.105 399.895 672 401 672C402.105 672 403 671.105 403 670Z"
          fill="white"
        />
        <path
          d="M442 684.5C442 682.567 440.433 681 438.5 681C436.567 681 435 682.567 435 684.5C435 686.433 436.567 688 438.5 688C440.433 688 442 686.433 442 684.5Z"
          fill="white"
        />
        <path
          d="M296 688C296 686.343 294.657 685 293 685C291.343 685 290 686.343 290 688C290 689.657 291.343 691 293 691C294.657 691 296 689.657 296 688Z"
          fill="white"
        />
        <path
          d="M251 723.5C251 721.567 249.433 720 247.5 720C245.567 720 244 721.567 244 723.5C244 725.433 245.567 727 247.5 727C249.433 727 251 725.433 251 723.5Z"
          fill="white"
        />
        <path
          d="M427 660.5C427 658.567 425.433 657 423.5 657C421.567 657 420 658.567 420 660.5C420 662.433 421.567 664 423.5 664C425.433 664 427 662.433 427 660.5Z"
          fill="white"
        />
        <path
          d="M351.498 661C351.498 653.545 345.008 647.5 337 647.5C345.008 647.5 351.498 641.458 351.498 634C351.498 641.458 357.992 647.5 366 647.5C357.992 647.5 351.498 653.545 351.498 661Z"
          fill="white"
        />
        <path
          d="M232.999 711C232.999 705.478 228.075 701 222 701C228.075 701 232.999 696.525 232.999 691C232.999 696.525 237.925 701 244 701C237.925 701 232.999 705.478 232.999 711Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_f"
            x="896"
            y="789"
            width="302.538"
            height="170.16"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
          </filter>
          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use href="#image0" transform="scale(0.25)" />
          </pattern>
          <linearGradient
            id="paint0_linear_greenPlanet"
            x1="2542.11"
            y1="1081.07"
            x2="2451.58"
            y2="1039.9"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#25BCB3" />
            <stop offset="1" stopColor="#E98FEB" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_greenPlanetStripes"
            x1="2509.33"
            y1="1045.59"
            x2="2520.02"
            y2="1105.45"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#3090B9" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="2504.43"
            y1="1029.48"
            x2="2493.49"
            y2="1090.7"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#3090B9" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="1395.6"
            y1="235.037"
            x2="1662.83"
            y2="678.945"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#3D135E" />
            <stop offset="0.688888" stopColor={bIsDark ? palette.darkPurple : '#6F3DAF'} />
            <stop offset="1" stopColor={bIsDark ? palette.darkPurple : '#8C15C4'} />
          </linearGradient>
          <linearGradient id="paint4_linear" x1="1677" y1="256" x2="1913" y2="340" gradientUnits="userSpaceOnUse">
            <stop stopColor="#C41574" />
            <stop offset="1" stopColor="#FAAC64" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="1356.27"
            y1="309.815"
            x2="1189.7"
            y2="193.822"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#731EB6" />
            <stop offset="1" stopColor="#B21EB6" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="661.065"
            y1="585.023"
            x2="720.948"
            y2="557.851"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#8125BC" />
            <stop offset="1" stopColor="#E98FEB" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="682.731"
            y1="561.52"
            x2="675.631"
            y2="601.174"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#B241B5" />
          </linearGradient>
          <linearGradient
            id="paint8_linear"
            x1="685.968"
            y1="550.842"
            x2="693.23"
            y2="591.397"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#B241B5" />
          </linearGradient>
          <linearGradient
            id="paint9_linear"
            x1="1040.09"
            y1="1103.06"
            x2="972.21"
            y2="1170.23"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#D307B2" />
            <stop offset="0.913978" stopColor="#6F4EBF" />
          </linearGradient>
          <radialGradient
            id="paint10_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1886 658.001) rotate(134.502) scale(230.009 229.974)">
            <stop stopColor="white" />
            <stop offset="1" stopColor="#FFDEC6" stopOpacity="0.1" />
          </radialGradient>
          <linearGradient
            id="paint11_linear"
            x1="2008.89"
            y1="535.99"
            x2="1757.91"
            y2="782.736"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#FCD36C" />
            <stop offset="1" stopColor="#E1833E" />
          </linearGradient>
          <linearGradient
            id="paint15_linear"
            x1="1245.42"
            y1="757.981"
            x2="1045.75"
            y2="757.981"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint19_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint20_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint21_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint22_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint23_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint24_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint25_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint26_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint27_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint28_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint29_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint30_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint31_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint32_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint33_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint34_linear"
            x1="1239.64"
            y1="761.288"
            x2="1039.97"
            y2="761.288"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint35_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint36_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint37_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint38_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint39_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint40_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint41_linear"
            x1="1222.63"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint42_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint43_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint44_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint45_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint46_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint47_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint48_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint49_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint50_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint51_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint52_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint53_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint54_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint55_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint56_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint57_linear"
            x1="1222.63"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint58_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint59_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint60_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint61_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint62_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint63_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint64_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint65_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint66_linear"
            x1="1222.62"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint67_linear"
            x1="1222.63"
            y1="755.048"
            x2="1022.95"
            y2="755.048"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint68_linear"
            x1="1222.63"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient
            id="paint69_linear"
            x1="1222.62"
            y1="755.047"
            x2="1022.95"
            y2="755.047"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#C5ECFB" />
            <stop offset="1" stopColor="#B4E4F9" />
          </linearGradient>
          <linearGradient id="paint70_linear" x1="656" y1="932" x2="591" y2="945" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B864FA" />
            <stop offset="1" stopColor="#4D15C4" />
            <stop offset="1" stopColor="#8864D6" />
          </linearGradient>
          <linearGradient
            id="paint71_linear"
            x1="1548.93"
            y1="1209.19"
            x2="1735.47"
            y2="1124.25"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#4B76C3" />
            <stop offset="0.568288" stopColor="#8FDAEB" />
            <stop offset="0.833917" stopColor="#FAA65B" />
          </linearGradient>
          <linearGradient
            id="paint72_linear"
            x1="1616.51"
            y1="1136.16"
            x2="1594.52"
            y2="1259.41"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#416DB5" />
          </linearGradient>
          <linearGradient
            id="paint73_linear"
            x1="1626.6"
            y1="1102.98"
            x2="1649.09"
            y2="1229.03"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#416DB5" />
          </linearGradient>
          <linearGradient
            id="paint74_linear"
            x1="425.335"
            y1="605.957"
            x2="190.017"
            y2="1104.34"
            gradientUnits="userSpaceOnUse">
            <stop stopColor={bIsDark ? palette.darkPurple : '#4D1677'} />
            <stop offset="1" stopColor={bIsDark ? palette.darkPurple : '#8025BC'} />
          </linearGradient>
          <radialGradient
            id="paint75_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(452.097 745.271) rotate(160.147) scale(65.5803 65.2451)">
            <stop stopColor="#130204" stopOpacity="0.13" />
            <stop offset="0.711321" stopColor="#FEF9F9" stopOpacity="0" />
          </radialGradient>
          <linearGradient
            id="paint76_linear"
            x1="474.471"
            y1="739"
            x2="434.006"
            y2="756.895"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#A527B8" />
            <stop offset="0.574717" stopColor="#570B10" />
          </linearGradient>
          <linearGradient
            id="paint77_linear"
            x1="455.521"
            y1="731.767"
            x2="451.248"
            y2="756.351"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#752F1F" />
          </linearGradient>
          <linearGradient
            id="paint78_linear"
            x1="459.92"
            y1="722.781"
            x2="464.996"
            y2="751.25"
            gradientUnits="userSpaceOnUse">
            <stop offset="1" stopColor="#752F1F" />
          </linearGradient>
          <clipPath id="clip0">
            <rect
              width="96.806"
              height="44.1453"
              transform="matrix(-0.674078 0.73866 -0.737321 -0.675543 2558.55 1041.88)"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1">
            <rect
              width="64.0707"
              height="29.2112"
              transform="matrix(0.673217 0.739445 0.736533 -0.676402 650.193 559.061)"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2">
            <rect
              width="266.043"
              height="122.108"
              transform="matrix(0.664623 0.747179 0.746727 -0.665131 1477 1121.94)"
              fill="white"
            />
          </clipPath>
          <image
            id="image0"
            width="4"
            height="4"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJlj3P3s538GJMDEgAYICwAA7IoDoZIfGRoAAAAASUVORK5CYII="
          />
        </defs>
      </svg>
    </div>
  );
};

export default withContent(withTheme(withStyles(styles)(AboutPageShape)));
